/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-12-01 10:05:03
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-08 13:37:47
 */
import { SearchOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Form, Input, Modal, Row, Select, Space } from 'antd'
import { TableRowSelection } from 'antd/lib/table/interface'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectEdition } from '../../../../app/applicationSlice'
import { RootDispatch } from '../../../../app/store'
import { EditableList } from '../../../../compnents/list/EditableList'
import { outpatientProjectOptions } from '../../../../models/toothPatient'
import { MorePatientColumns } from '../../patient/patientList/columns'
import {
  getPatientByGroupAsync,
  getPatientGroupAsync,
  setGroupList,
  selectAttendingDoctorList,
  selectCounselorList,
  setAttendingDoctorList,
  setCounselorList,
  selectGroupList,
} from '../../patient/patientSlice'
import {
  getCounselor,
  getPatientOptionsAsync,
  selectPatientBirthday,
  selectSendIDs,
  setSendIDs,
} from '../toothHomeSlice'
import styles from './modal.module.css'
import { DateRangeGH, DateSelect } from "../../../../compnents/form/DateSelect";

interface MorePatientProps {
  visible: boolean
  onCancel: () => void
  onOk: () => void
}

export const MorePatient = ({
  visible,
  onOk,
  onCancel,
}: MorePatientProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const [loading, setLoading] = useState(false)

  const attendingDoctorList = useSelector(selectAttendingDoctorList)

  const counselorList = useSelector(selectCounselorList)

  const allGroupLists = useSelector(selectGroupList)

  const PatientBirthday = useSelector(selectPatientBirthday)

  const selectedKeys = useSelector(selectSendIDs)

  const [currentSelect, setCurrentSelect] = useState<any[]>([])

  const [classificationList, setClassificationList] = useState<any>() //就诊项目数据

  useEffect(() => {
    if (visible) {
      if (selectedKeys) {
        setCurrentSelect([...selectedKeys, ...currentSelect])
      }
    }
  }, [selectedKeys, visible])

  useEffect(() => {
    if (!visible) return
    dispatch(
      getCounselor({
        current: 1,
        size: 100,
        stationCategory: 1,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        dispatch(setAttendingDoctorList(res.records))
      })
    dispatch(
      getCounselor({
        current: 1,
        size: 100,
        stationCategory: 4,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        dispatch(setCounselorList(res.records))
      })
    dispatch(getPatientGroupAsync())
      .then(unwrapResult)
      .then((res: any) => {
        dispatch(setGroupList(res.records))
      })
  }, [visible])

  const getPage = () => {
    setLoading(true)
    dispatch(
      getPatientByGroupAsync({
        ...params,
        groupId: params.groupId || 0,
        startTime: PatientBirthday[0],
        endTime: PatientBirthday[1],
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const data = {
          total: res.total,
          items: res.records,
        }
        setPage(data)
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (!visible) return
    getPage()
  }, [params, visible])

  useEffect(() => {
    form.setFieldsValue({
      groupId: 0,
    })
  }, [])

  useEffect(() => { 
    dispatch(getPatientOptionsAsync({ types: '0,1,2' }))
      .then(unwrapResult)
      .then((res: any) => {
        const findItems = (type: string) => {
          return res ? res?.find((t: any) => t.type == type)?.items?.map((v: any) => {
            return {
              name: v.context,
              value: v.sortNo,
            }
          }) : []
        }
        setClassificationList({
          treatmentItemList: findItems('2'),
        })
      })
  }, [])

  return (
    <Modal
      visible={visible}
      onCancel={() => {
        onCancel()
      }}
      width={1350}
      destroyOnClose
      bodyStyle={{
        height: 700,
        padding: '0 10px',
      }}
      title='选择患者'
      footer={null}
      centered
    >
      <div className={styles.main}>
        <Form
          form={form}
          onFinish={(values) => {
            if(!values?.settlementTimeHead && values?._dateRange == 6){
              return 
            }
            setParams({
              ...params,
              ...values,
              current: 1,
            })
          }}
        >
          <div className={styles.query}>
            <Space>
              <Form.Item name='key'>
                <Input
                  style={{ width: '20em' }}
                  autoComplete='off'
                  prefix={<SearchOutlined />}
                  placeholder='患者姓名/助记码/手机号/病历号'
                  allowClear
                  onChange={form.submit}
                />
              </Form.Item>
              {hisVersion == 1 ? (
                <>
                  <Form.Item name='attendingDoctorId'>
                    <Select
                      style={{ width: '8em' }}
                      placeholder='主治医生'
                      allowClear
                      onChange={form.submit}
                      showSearch
                      filterOption={(input, option: any) =>
                        (option?.children ?? '')
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {attendingDoctorList.map((d) => (
                        <Select.Option key={d.id} value={d.id}>
                          {d.realname}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item name='counselorId'>
                    <Select
                      style={{ width: '8em' }}
                      placeholder='咨询师'
                      allowClear
                      showSearch
                      onChange={form.submit}
                      filterOption={(input, option: any) =>
                        (option?.children ?? '')
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {counselorList.map((d) => (
                        <Select.Option key={d.id} value={d.id}>
                          {d.realname}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item name='treatmentItem'>
                    <Select
                      style={{ width: '8em' }}
                      placeholder='就诊项目'
                      allowClear
                      onChange={form.submit}
                    >
                      {classificationList?.treatmentItemList?.map((d: any) => (
                        <Select.Option key={d.name} value={d.name}>
                          {d.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item name='groupId'>
                    <Select
                      style={{ width: '8em' }}
                      placeholder='患者分组'
                      allowClear
                      onChange={form.submit}
                    // defaultValue='0'
                    >
                      {allGroupLists.map((d) => (
                        <Select.Option key={d.id} value={d.id}>
                          {d.groupName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </>
              ) : (
                <></>
              )}
              <DateSelect
                style={{ width: '10em' }}
                labelPrefix=''
                namePrefix='settlementTime'
                placeholder='最近一次结算时间'
                onChange={() => form.submit()}
                options={DateRangeGH}
              />
              <Button type='primary' htmlType='submit'>
                查询
              </Button>
            </Space>
          </div>
        </Form>
        <EditableList
          loading={loading}
          className={styles.table}
          rowKey={(v, i) => {
            return `${v.patient.id}`
          }}
          page={{
            current: params.current,
            size: params.size,
            total: page.total,
            items: page.items,
          }}
          columns={MorePatientColumns(params.size * (params.current - 1))}
          onChangePage={(current, size) =>
            setParams({
              ...params,
              current,
              size: size || 20,
            })
          }
          onRow={(record) => ({
            onClick: () => {
              let data = []
              if (!currentSelect.includes(record.patient.id.toString())) {
                data = [record.patient.id.toString(), ...currentSelect]
              } else {
                data = currentSelect.filter(
                  (v) => v != record.patient.id.toString()
                )
              }
              setCurrentSelect(data)
            },
          })}
          rowSelection={{
            selectedRowKeys: currentSelect,
            onSelectAll: (
              selected: any,
              selectedRows: any,
              changeRows: any
            ) => {
              let data: any = []
              if (selected) {
                data = [
                  ...changeRows.map((v: any) => v.patient.id.toString()),
                  ...currentSelect,
                ]
              } else {
                data = currentSelect.filter(
                  (item) =>
                    !changeRows.some(
                      (ele: any) => ele.patient.id.toString() === item
                    )
                )
              }
              setCurrentSelect(data)
              // dispatch(setSendIDs(data))
            },
            onSelect: (record, selected) => {
              let data = []
              if (selected) {
                data = [record.patient.id.toString(), ...currentSelect]
              } else {
                data = currentSelect.filter(
                  (v) => v != record.patient.id.toString()
                )
              }
              setCurrentSelect(data)
              // dispatch(setSendIDs(data))
            },
          }}
        />
        <Row
          justify='space-between'
          style={{
            padding: '0 10px 0 30px`',
          }}
        >
          <div>
            已选择<span style={{ color: 'red' }}>{currentSelect.length}</span>
            位患者
          </div>
          <Space>
            <Button
              onClick={() => {
                onCancel()
                setCurrentSelect([])
              }}
            >
              {' '}
              取消
            </Button>
            <Button
              type='primary'
              onClick={() => {
                const list = Array.from(
                  new Set([...selectedKeys, ...currentSelect])
                )
                dispatch(setSendIDs(currentSelect))
                setCurrentSelect([])
                onOk()
              }}
            >
              确认
            </Button>
          </Space>
        </Row>
      </div>
    </Modal>
  )
}
